<template>
  <div class="mt-1">
    <template v-for="(line_item_discount, k) in line_item_discounts">
      <div v-if="line_item_discount.type === 'product_quantity_discount'" :key="k" class="small text-success">
        <template v-if="line_item_discount.object.discount_type === 'percentage'">{{ line_item_discount.object.discount_value }}%</template>
        <template v-else>{{ line_item_discount.value | numberToRs }}</template>
        quantity discount applied
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'SaleCartLineItemDiscounts',
  props: [
    'line_item_discounts'
  ]
}
</script>



// WEBPACK FOOTER //
// src/components/sale/partials/cart/LineItemDiscounts.vue